import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { ServiceEdit, type ServiceFormValues } from "../components/ServiceEdit";
import { useCreateService } from "../hooks/serviceQueries";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { useWorkspaceOperation } from "@/shared/hooks/useWorkspaceOperation";

export function ServiceAddPage() {
  const { goToServiceDetails } = useAppNavigation();
  const { businessId } = useCurrentBusiness();
  const createServiceMutation = useCreateService();
  const captureOperation = useWorkspaceOperation();

  const handleSubmit = (data: ServiceFormValues) => {
    if (!businessId || createServiceMutation.isPending) return;
    const isCurrent = captureOperation();
    createServiceMutation.mutate(
      {
        ...data,
        businessId,
        description: data.description || null,
        color: data.color || null,
      },
      {
        onSuccess: (service) => { if (isCurrent()) goToServiceDetails(service.id, "finish"); },
      }
    );
  };

  const emptyService = {
    name: "",
    description: "",
    basePrice: null,
    durationMinutes: null,
    bufferBeforeMinutes: null,
    bufferAfterMinutes: null,
    isActive: true,
    color: "#28613d",
  };

  if (!businessId) {
    return (
      <Page>
        <PageHeader title="Add service" />
        <PageContent>
          <EmptyState message="No business selected" />
        </PageContent>
      </Page>
    );
  }

  return (
    <ServiceEdit
      key={businessId}
      service={emptyService}
      onSubmit={handleSubmit}
      isSubmitting={createServiceMutation.isPending}
      error={createServiceMutation.error}
      title="Add service"
    />
  );
}
